import { render, staticRenderFns } from "./DetailMaterial.vue?vue&type=template&id=a61c2336&scoped=true"
import script from "./DetailMaterial.vue?vue&type=script&lang=js"
export * from "./DetailMaterial.vue?vue&type=script&lang=js"
import style0 from "./DetailMaterial.vue?vue&type=style&index=0&id=a61c2336&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61c2336",
  null
  
)

export default component.exports